<template>
	<div ref="view" class="select-view" @focus="onFocus" @blur="onBlur" @click.stop="toggleOptions" :style="_style">
		<div class="input" :style="_inputStyle">{{ value ? _label : (inline ? label : '') }}</div>
		<div v-if="!inline" class="label" :style="{
			...theme.typography.body2,
			..._labelStyle
		}">{{ label }}</div>
		<div v-if="!inline" class="underline" :style="_underlineStyle"></div>
		<div v-if="!inline" class="underline colored" :style="_underlineColoredStyle"></div>
		<div v-show="open" class="options" :level="1" :style="{
			zIndex: 10000,
			top: inline ? '30px' : '54px'
		}">
			<div v-for="(opt, i) in _options" :key="i">
				<div v-if="opt !== null" class="option" :style="_optionStyle" @click.stop="onOptionClick(opt)">
					<span class="leveled" :style="{ paddingLeft: (opt.level ? opt.level * 20 : 0) + 'px' }">{{ opt.label }}</span>
					<div class="buttons">
						<svg-icon v-if="opt.value && mutable" class="button delete" icon="cross" @click.stop="onDeleteOptionClick(opt)" />
						<svg-icon v-if="opt.value && mutable && levels" class="button add" icon="plus" @click.stop="onAddChildClick(opt)" />
					</div>
				</div>
				<div v-if="opt === null" class="separator"></div>
			</div>
			<div v-if="mutable">
				<div class="separator"></div>
			</div>
			<div v-if="mutable">
				<div class="option" :style="_optionStyle" @click.stop="onAddClick">
					Tilføj
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import theme from '@/mixins/theme';
	import focus from '@/mixins/focus';

	export default {
		mixins: [theme, focus],
		props: {
			options: {
				type: Array,
				default() {
					return [];
				}
			},
			label: {
				type: String,
				default: ''
			},
			value: {
				type: [Object, Number, String],
				default: null
			},
			colors: {
				type: Object,
				default() {
					return {};
				}
			},
			levels: {
				type: Boolean,
				default: false
			},
			mutable: {
				type: Boolean,
				default: false
			},
			inline: {
				type: Boolean,
				default: false
			},
			clear: {
				type: String,
				default: null
			}
		},
		watch: {
			open(n) {
				if (n || this.focus) {
					this.focus_on();
				} else {
					this.focus_off();
				}
			}
		},
		data() {
			return {
				focus: false,
				open: false
			};
		},
		computed: {
			_label() {
				if (this.value !== null) {
					console.log('value is', this.value, this.options);

					const self = this;
					const r = this.options.find((item) => { return item && item.value == self.value; });
					if (r) return r.label;
				}

				return '';
			},
			_options() {
				var r = [];

				if (this.clear !== null) {
					r.push({
						label: this.clear,
						value: null
					});

					r.push(null);
				}

				r = r.concat(Array.from(this.options));

				return r;
			},
			_valueToString() {
				return this.value ? this.value.toString() : '';
			},
			_colors() {
				return {
					...{
						background: this.theme.colors.backgroundVariant,
						underline: 	this.theme.colors.onBackgroundVariant,
						primary: 	this.theme.colors.primary,
						label:		this.theme.colors.onBackgroundVariant,

					},
					...this.colors
				};
			},
			_style() {
				return {
					backgroundColor: this.inline ? 'none' : this._colors.background,
					height: this.inline ? '30px' : '54px'
				};
			},
			_inputStyle() {
				return {
					...this.theme.typography.body1,
					height: this.inline ? '30px' : '54px',
					lineHeight: this.inline ? '30px' : '38px',
					paddingTop: this.inline ? '0' : '18px',
					paddingLeft: this.inline ? '0' : '15px',
				};
			},
			_optionStyle() {
				return {
					...this.theme.typography.body1,
					paddingRight: this.mutable ? '60px' : '40px'
				};
			},
			_underlineStyle() {
				return {
					backgroundColor: '#ccc'
				};
			},
			_underlineColoredStyle() {
				return {
					transition: 		'left 300ms ' + this.theme.transitions.cubic + ', width 300ms ' + this.theme.transitions.cubic,
					backgroundColor:	this._colors.primary,
					left: 				this.focus ? '0%' : '50%', 
					width: 				this.focus ? '100%' : '0%' 
				};
			},
			_labelStyle() {
				return {
					fontSize:			this._valueToString.length > 0 ? '12px' : '16px',
					transition:			'line-height 300ms ' + this.theme.transitions.cubic + ', color 300ms ' + this.theme.transitions.cubic + ', font-size 300ms ' + this.theme.transitions.cubic,
					lineHeight: 		this._valueToString.length > 0 || this.inline ? '30px' : '52px',
					color: 				this.focus ? this._colors.primary : this._colors.label
				};
			}
		},
		methods: {
			onFocus() {
				console.log('blur');
				this.focus_on();
			},
			onBlur() {
				console.log('blur');
				this.focus_off();
			},
			onClick() {
				//this.$refs.input.focus();
			},
			onOptionClick(option) {
				console.log('opt click', option.value === null ? null : option.value);

				if (option.action) {
					this.open = false;
					option.action();
					return;
				}

				console.log('opt click');
				this.$emit('input', option.value === null ? null : option.value);
				this.open = false;
				this.$refs.view.focus();
			},
			onAddClick() {
				console.log('add click');
				this.$emit('add');
				this.open = false;
				this.$refs.view.focus();
			},
			onAddChildClick(option) {
				console.log('add child click');
				this.$emit('addChild', option);
				this.open = false;
				this.$refs.view.focus();
			},
			onDeleteOptionClick(option) {
				console.log('delete click');
				this.$emit('delete', option);
				this.open = false;
				this.$refs.view.focus();
			},
			toggleOptions() {
				console.log('toggle');
				this.open = !this.open;
			}
		},
		created() {
			/*if (typeof this.value != 'object') {
				for (var i = 0; i < this.options.length; ++i) {
					const opt = this.options[i];

					if (opt.value == this.value) {
						this.$emit('input', opt);
					}
				}
			}*/
		}
	}
</script>

<style lang="scss" scoped>
	.select-view {
		display: inline-block;
		background-color: none;
		box-sizing: border-box;
		height: 54px;
		position: relative;
		width: 100%;
		cursor: pointer;

		& > input, & > .input {
			outline: none;
			background: none;
			border: none;
			width: 100%;
			height: 54px;
			box-sizing: border-box;
			padding: 18px 15px 0 15px;
			position: absolute;
			bottom: 2px;
			line-height: 38px;
		}

		& > .label {
			position: absolute;
			left: 0;
			top: 0;
			width: 100%;
			height: 100%;
			pointer-events: none;
			padding-left: 15px;
		}

		& > .underline {
			position: absolute;
			left: 0;
			bottom: 0;
			width: 100%;
			height: 1px;

			&.colored {
				height: 2px;
			}
		}

		& > .options {
			position: absolute;
			left: 0;
			top: 54px;
			background-color: white;
			min-width: 100%;
			max-height: 350px;
			overflow-y: auto;

			-webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			-moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);
			box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.15);

			& > div {
				& > .option {
					padding: 10px 20px 10px 15px;
					position: relative;
					white-space: nowrap;

					& .buttons {
						position: absolute;
						top: 11px;
						right: 10px;

						& > .button {
							float: right;
							margin-left: 10px;
							fill: rgb(177, 177, 177);

							&.add {
								transform: scale(0.8);
							}
						}
					}

					&:hover {
						background-color: #F5F5F5;
					}
				}

				& > .separator {
					height: 1px;
					background-color: #d6d6d6;
					cursor: default;
				}
			}
		}
	}
</style>